export default __webpack_public_path__ + "static/media/water6.235f491e.png";